/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency_codes';
import '../common/time';
import '../common/payment';
import '../common/instrument';
import '../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "fees": {
        "nested": {
          "PaymentPrice": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "priceSelectors": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "validPlatformAttributes": {
                "type": ".squareup.fees.ValidPlatformAttributes",
                "id": 3,
                "rule": "optional"
              },
              "simpleRate": {
                "type": ".squareup.fees.SimpleRate",
                "id": 4,
                "rule": "optional"
              },
              "costPlusRate": {
                "type": ".squareup.fees.CostPlusRate",
                "id": 5,
                "rule": "optional"
              },
              "currency": {
                "type": ".squareup.common.CurrencyCode",
                "id": 6,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 7,
                "rule": "optional"
              },
              "expiresAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 8,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 9,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 10,
                "rule": "optional"
              }
            }
          },
          "ValidPlatformAttributes": {
            "fields": {
              "entryMethods": {
                "type": ".squareup.common.payment.EntryMethod",
                "id": 1,
                "rule": "repeated"
              },
              "cardBrands": {
                "type": ".squareup.common.instrument.InstrumentType",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "SimpleRate": {
            "fields": {
              "basisPoints": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "fixedAmount": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "CostPlusRate": {
            "fields": {
              "holdRateBasisPoints": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "holdRateFixedAmount": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "costPlusBasisPoints": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "costPlusFixedAmount": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "PaymentPriceAllocationAttributes": {
            "fields": {
              "paymentPriceSpec": {
                "type": ".squareup.fees.PaymentPriceAllocationSpec",
                "id": 1,
                "rule": "optional"
              },
              "appPlatformToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "PaymentPriceAllocationSpec": {
            "fields": {
              "party": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "priceSelectors": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "feeCalculationAmount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "PaymentPriceAllocation": {
            "fields": {
              "party": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "priceSelectors": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "paymentPrice": {
                "type": ".squareup.fees.PaymentPrice",
                "id": 3,
                "rule": "optional"
              },
              "partyMoney": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "paymentPriceToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fees?.nested?.PaymentPrice && !$root.nested?.squareup?.nested?.fees?.nested?.ValidPlatformAttributes && !$root.nested?.squareup?.nested?.fees?.nested?.SimpleRate && !$root.nested?.squareup?.nested?.fees?.nested?.CostPlusRate && !$root.nested?.squareup?.nested?.fees?.nested?.PaymentPriceAllocationAttributes && !$root.nested?.squareup?.nested?.fees?.nested?.PaymentPriceAllocationSpec && !$root.nested?.squareup?.nested?.fees?.nested?.PaymentPriceAllocation) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A PaymentPrice.
 * --
 *
 * SOURCE PaymentPrice @ squareup/fees/models.proto at 17:1
 */
export const PaymentPrice = $root.lookupType('squareup.fees.PaymentPrice');
fixType(PaymentPrice, {
  priceSelectors: {
    required: true
  },
  currency: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentPrice);
/**
 * @desc Describes the payment attributes for which the PaymentPrice is valid
 *
 * SOURCE ValidPlatformAttributes @ squareup/fees/models.proto at 60:1
 */
export const ValidPlatformAttributes = $root.lookupType('squareup.fees.ValidPlatformAttributes');
fixType(ValidPlatformAttributes);
Builder.createAndAttachToType(ValidPlatformAttributes);
/**
 * @desc Describes a simple rate with a variable and fixed component.
 *
 * SOURCE SimpleRate @ squareup/fees/models.proto at 72:1
 */
export const SimpleRate = $root.lookupType('squareup.fees.SimpleRate');
fixType(SimpleRate);
Builder.createAndAttachToType(SimpleRate);
/**
 * --
 * @desc Describes a cost plus rate. A cost plus rate is composed of a "hold rate" that
 * applies initially before the cost is known. Once the cost is known, the final price
 * for the payment will be defined entirely by the cost plus rate.
 * --
 *
 * SOURCE CostPlusRate @ squareup/fees/models.proto at 91:1
 */
export const CostPlusRate = $root.lookupType('squareup.fees.CostPlusRate');
fixType(CostPlusRate);
Builder.createAndAttachToType(CostPlusRate);
/**
 * --
 * @desc Encapsulates attributes clients need to provide with the payment in order to use payment prices.
 * --
 *
 * SOURCE PaymentPriceAllocationAttributes @ squareup/fees/models.proto at 120:1
 */
export const PaymentPriceAllocationAttributes = $root.lookupType('squareup.fees.PaymentPriceAllocationAttributes');
fixType(PaymentPriceAllocationAttributes, {
  paymentPriceSpec: {
    required: true
  },
  appPlatformToken: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentPriceAllocationAttributes);
/**
 * SOURCE PaymentPriceAllocationSpec @ squareup/fees/models.proto at 132:1
 */
export const PaymentPriceAllocationSpec = $root.lookupType('squareup.fees.PaymentPriceAllocationSpec');
fixType(PaymentPriceAllocationSpec, {
  party: {
    notEmpty: true
  },
  priceSelectors: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentPriceAllocationSpec);
/**
 * --
 * @desc price allocation details. Defines how the PaymentPrices are allocated.
 * N.B. This is the one used in the square payments stack, not externally exposed
 * --
 *
 * SOURCE PaymentPriceAllocation @ squareup/fees/models.proto at 192:1
 */
export const PaymentPriceAllocation = $root.lookupType('squareup.fees.PaymentPriceAllocation');
fixType(PaymentPriceAllocation, {
  party: {
    notEmpty: true
  },
  priceSelectors: {
    required: true
  },
  partyMoney: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentPriceAllocation);